export const contactus = {
  english: {
    title: 'Contact Us',
    sggsProject: 'Contact Us',
    subTagLine: '',
    theVision: '',
    paragraph1:
      'We\'d love to hear from you. Our team does their best to respond in a timely fashion. Please let us know what you would like to discuss and we\'ll have the appropriate team member contact you right away.',
    correctionLabel: 'Suggest Corrections',
    paragraph2:
      'The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team also acknowledges that theirs is a work in progress.',
    paragraph3:
    'Please contact us via email to request a correction if you have identified any error, minor or significant.',

    correctionEmail: 'corrections@sikhri.org',
  },

  panjabi: {
    title: 'Contact Us',
    sggsProject: 'Contact Us',
    subTagLine: '',
    theVision: '',
    paragraph1:
      'We\'d love to hear from you. Our team does their best to respond in a timely fashion. Please let us know what you would like to discuss and we\'ll have the appropriate team member contact you right away.',
    correctionLabel: 'Suggest Corrections',
    paragraph2:
      'The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team also acknowledges that theirs is a work in progress.',
    paragraph3:
    'Please contact us via email to request a correction if you have identified any error, minor or significant.',

    correctionEmail: 'corrections@sikhri.org',
  },
};
